<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            <span>Hasta Listesi</span>
            <span>
                <el-tooltip v-if="surecVisible" content='Filtrele'
                            :open-delay="200"
                            placement="bottom">
                    <el-button size="mini"
                               class="refresh"
                               v-on:click="filterDialogVisible = true"
                               type="text"
                               icon="mdi mdi-filter-variant mdi-18px">
                    </el-button>
                </el-tooltip>
                <el-tooltip v-else content='Filtrele Sıfırla'
                            :open-delay="200"
                            placement="bottom">
                    <el-button size="mini"
                               class="refresh"
                               v-on:click="clearable"
                               type="text"
                               icon="mdi mdi-filter-remove mdi-18px">
                    </el-button>
                </el-tooltip>
                <export-excel
                        class="btn btn-default"
                        :data="excelTable"
                        worksheet="My Worksheet"
                        name="hastalistesi.xls">
                             <el-tooltip content='Excel'
                                         :open-delay="200"
                                         placement="bottom">
                                <el-button size="mini"
                                           style="position: absolute;
                                                    top: 3px;
                                                    right: 35px;
                                                    color: white;"
                                           v-on:click="exportExcel"
                                           type="text"
                                           icon="mdi mdi-file-excel mdi-18px">
                                </el-button>
                            </el-tooltip>
                </export-excel>
            </span>
        </div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col class="margin-bottom-10" :span="24">
                <el-radio-group v-if="surecVisible" size="mini" v-on:change="handleChange($event)" v-model="radio"
                                fill="#E5F5F9"
                                text-color="gray">

                    <el-badge :value="tamamlanan" v-if="(root || yetkili || yetkiList.hastaOnay)"
                              class="item tamamlanan">
                        <el-radio-button label="1">
                            <i class="mdi mdi-account mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                            <span style="color: #13ce66" class="durum">Tamamlanan</span>
                        </el-radio-button>
                    </el-badge>
                    <el-badge :value="islemde" v-if="(root || yetkili || yetkiList.islemde)" class="item islemde">
                        <el-radio-button label="2">
                            <i class="mdi mdi-account mdi-18px" style="color: #00bcd0; margin-right: 5px"></i>
                            <span style="color: #00bcd0" class="durum">İşlemde</span>
                        </el-radio-button>
                    </el-badge>
                    <el-badge :value="pasif" v-if="(root || yetkili || yetkiList.islemde)" class="item silinen">
                        <el-radio-button label="0">
                            <i class="mdi mdi-account mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                            <span style="color: #ec205f" class="durum">Silinen</span>
                        </el-radio-button>
                    </el-badge>
                </el-radio-group>
                <div class="aciklamaListesi">
                    <ul>
                        <li class="renk-tedavi"><i class="el-icon-postcard"></i> Tedavi Detay</li>
                        <li class="renk-cerrahi"><i class="mdi mdi-tooth-outline"></i> Cerrahi Tanımlama</li>
                        <li class="renk-randevu"><i class="mdi mdi-calendar-text"></i> Randevu Tanımlama</li>
                        <li class="renk-detay"><i class="mdi mdi-calendar-clock"></i> Hasta Detay</li>
                        <li class="renk-garantiKart"><i class="el-icon-edit"></i> Garanti Kartı Teslim</li>
                        <li class="renk-duzenle"><i class="el-icon-edit"></i> Düzenle</li>
                        <li class="renk-tamamlandi"><i class="mdi mdi-check"></i> Tamamla</li>
                        <li class="renk-silinen"><i class="mdi mdi-close"></i> Sil</li>
                    </ul>
                </div>
            </el-col>
            <el-table
                    :data="tumHastaListesi"
                    ref="filterTable"
                    border
                    stripe
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        sortable
                        label="Hasta ID"
                        prop="hastaId"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="garantiNo"
                        label="Garanti No"
                        width="130">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="auto">
                </el-table-column>
                <el-table-column
                        v-if="!surecVisible"
                        prop="durumDetay"
                        label="Durum"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="tcNo"
                        label="T.C."
                        width="150">
                </el-table-column>
                <el-table-column
                        label="Cinsiyet"
                        width="80">
                    <template slot-scope="scope">
                        <el-tooltip :content='scope.row.cinsiyet' :open-delay="200" placement="bottom">
                            <i v-if="scope.row.cinsiyet === 'Kadın'" style="color: #ec205f"
                               class="mdi mdi-human-female mdi-24px"></i>
                            <i v-else style="color: #0075c3" class="mdi mdi-human-male mdi-24px"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="yas"
                        label="Yaş"
                        width="80">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="kayitTarihi"
                        label="Kayıt Tarihi"
                        width="200">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="cerrahi[0].tarih"
                        label="Cerrahi Uygulama Tarihi"
                        width="220">
                </el-table-column>
                <!--<el-table-column-->
                <!--:filters="filtersDoctor"-->
                <!--:filter-method="filterDoctor"-->
                <!--filter-placement="bottom-end"-->
                <!--label="Doktor"-->
                <!--width="80">-->
                <!--<template slot-scope="scope">-->
                <!--<el-tooltip :content='scope.row.hekim[scope.row.hekim.length-1].adSoyad' :open-delay="200" placement="bottom">-->
                <!--<el-button style="cursor: pointer"-->
                <!--icon="mdi mdi-doctor mdi-24px" type="text"-->
                <!--v-on:click="hekimDetay(scope.row)"></el-button>-->
                <!--</el-tooltip>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="280">
                    <template slot="header" slot-scope="scope">
                        <el-input clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"
                                  placeholder="Ara" size="mini"></el-input>
                    </template>
                    <template slot-scope="scope">
                        <el-tooltip content='Hasta Detay' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #23313F"
                                       class="buttonEdit"
                                       icon="el-icon-postcard" type="text"
                                       v-on:click="hastaDetay(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2'" content='Cerrahi Tanımlama' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer;position:relative; top:-1px; color: #23313F"
                                       class="buttonEdit"
                                       icon="mdi mdi-tooth-outline" type="text"
                                       v-on:click="cerrahiTanimlama(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2'" content='Randevu Tanımlama' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer;position:relative; top:-1px;color: #9a9a9a"
                                       class="buttonEdit"
                                       icon="mdi mdi-calendar-text" type="text"
                                       v-on:click="randevuTanimlama(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon !== '0'" content='Hasta Süreç Detay' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer;position:relative; top:-1px;color: #0075c3"
                                       class="buttonEdit"
                                       icon="mdi mdi-calendar-clock" type="text"
                                       v-on:click="userdata = scope.row; dialogHastaSurec = true"></el-button>
                        </el-tooltip>
                        <el-popover
                                trigger="click"
                                class="padding-10"
                                v-if="scope.row.garantiKart === '0'"
                                placement="bottom"
                                width="200">
                            <p>Garanti Kartı Teslim Tarihi</p>
                            <el-date-picker
                                    style="width: 90%"
                                    size="mini"
                                    v-model="teslimTarihi"
                                    type="datetime"
                                    :picker-options="dateRangeOptions"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="Garanti Kartı Teslim Tarihi"
                                    default-time="12:00:00">
                            </el-date-picker>
                            <div style="text-align: right; margin: 10px">
                                <el-button size="mini" type="text" >Vazgeç</el-button>
                                <el-button type="primary" size="mini" v-on:click="garantiKartiTeslim(scope.row)">Kaydet</el-button>
                            </div>
                            <el-button
                                    slot="reference"
                                    style="cursor: pointer;color: #00a8a7"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-bank-card">
                            </el-button>
                        </el-popover>
                        <el-tooltip v-if="scope.row.garantiKart === '1'" :content='scope.row.teslimTarihi'
                                    :open-delay="200"
                                    placement="bottom">
                            <el-button
                                    style="cursor: pointer;color: rgba(76,102,102,0.42)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-bank-card">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2'" content='Düzenle'
                                    :open-delay="200"
                                    placement="bottom">
                            <el-button
                                    v-on:click="route('Hasta Güncelleme',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2'" content='Tamamla' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #13ce66"
                                       class="buttonEdit"
                                       icon="mdi mdi-check" type="text"
                                       v-on:click="handleCommand('1',scope.row,scope.$index)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2'" content='Sil' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #ec205f"
                                       class="buttonEdit"
                                       icon="mdi mdi-close" type="text"
                                       v-on:click="handleCommand('0',scope.row,scope.$index)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="margin-top-20"
                    v-if="surecVisible"
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
            <div style="font-style: italic" v-else>
                Aramış olduğunuz kritere uygun " {{search}} " veriler listelenmektedir. <br> Listeyi sıfırlamak için
                " <i class="mdi mdi-close-circle-outline"></i> " butonunu kullanabilirsiniz.
            </div>
        </div>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="durumChangeDialog"
                width="30%"
                center>
            <span>"{{selection.adSoyad}}" hasta durumunu değiştirmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="hastaDurumChange(selection,selectionIndex,tumHastaListesi,durum), durumChangeDialog = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="durumChangeDialog = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                :visible.sync="hastaDetaySurec"
                width="60%"
                center>

            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="margin-top-10">
                <div class="hastaKabulBaslikSerit animated fadeInUp">
                    <div class="hastaKabulBaslik">
                        <h1>{{hastaisimSoyisim}} Tedavi Detayı</h1>
                    </div>
                </div>
                <el-row class="ozel-row animated fadeInUp">

                    <el-col :lg="8" :md="8" :sm="24" :xs="24">
                        <div class="formBilgileri">
                            <div class="formBilgiBaslik">Hekim Bilgileri</div>
                            <div class="mobil-baslik">Hekim Bilgileri</div>
                            <div class="formElemanlari">
                                <div class="doktor-bilgi">
                                    <div class="input-effect">
                                        <div class="formBilgi">Adı Soyadı:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hekimAdi}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">Telefon:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hekimTel}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">E-Mail:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hekimMail}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">Klinik:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hekimKlinik}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :lg="8" :md="8" :sm="24" :xs="24">
                        <div class="formBilgileri">
                            <div class="formBilgiBaslik">Protez Bilgileri</div>
                            <div class="mobil-baslik">Protez Bilgileri</div>
                            <div class="formElemanlari">
                                <div class="doktor-bilgi">
                                    <div class="input-effect">
                                        <div class="formBilgi">Adı Soyadı:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{protezAdi}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">Telefon:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{protezTel}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :lg="8" :md="8" :sm="24" :xs="24">
                        <div id="hastaBilgileri" class="formBilgileri ozel-sagayasla">
                            <div class="mobil-baslik">Hasta Bilgileri</div>
                            <div class="formElemanlari">
                                <div class="doktor-bilgi">
                                    <div class="input-effect">
                                        <div class="formBilgi">T.C.:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hastatcNo}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">Adı Soyadı:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hastaisimSoyisim}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">Yaş / Cinsiyet:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hastaYas}} / {{hastaCinsiyet}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">İl:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hastaSehir}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">Telefon:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hastaTel}}</div>
                                    </div>
                                    <div class="input-effect">
                                        <div class="formBilgi">E-Mail:</div>
                                        <div class="effect-7 yazdir-bilgisi">{{hastaMail}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="formBilgiBaslik sagTaraf">Hasta Bilgileri</div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="animated fadeInUp" style="display: flex; justify-content: center">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <div class="grupBilgisi margin-top-20">
                            <p>Cerrahi Uygulama</p>
                        </div>
                        <div class="disOpsiyonlari" v-for="(item,index) in hastaCerrahiListesi">
                            <div class="opsiyonDiv disNumarasi-yazdir">
                                <div>Diş Numarası</div>
                                <div><span>{{item.disId}}</span></div>
                            </div>
                            <div class="opsiyonDiv">
                                <div>Tarih:</div>
                                <div>{{item.tarih}}</div>
                            </div>
                            <div class="opsiyonDiv">
                                <div>Ürün Adı:</div>
                                <div>{{item.urun}}</div>
                            </div>
                            <div class="opsiyonDiv">
                                <div>Ürün Lot:</div>
                                <div>{{item.urunLot}}</div>
                            </div>
                            <div class="opsiyonDiv">
                                <div>Ek Ürün Adı:</div>
                                <div>{{item.ekUrun}}</div>
                            </div>
                            <div class="opsiyonDiv">
                                <div>Ek Ürün Lot:</div>
                                <div>{{item.ekUrunLot}}</div>
                            </div>
                            <div class="opsiyonDiv">
                                <div>Ek Tedavi:</div>
                                <div>{{item.ekTedavi}}</div>
                            </div>
                            <div v-if="item.isq !==''" class="opsiyonDiv">
                                <div>ISQ:</div>
                                <div>{{item.isq}}</div>
                            </div>
                            <div class="disler-arasi-cizgi" v-if="index < hastaCerrahiListesi.length - 1"></div>
                        </div>
                        <div class="grupBilgisi">
                            <p>Randevu Bilgileri</p>
                        </div>
                        <div class="disOpsiyonlari randevular" v-for="(item,index) in hastaRandevuListesi">
                            <div class="opsiyonDiv">
                                <div>Randevu Tarihi:</div>
                                <div>{{item.tarih}}</div>
                            </div>
                            <div v-if="item.ekTedavi !==''" class="opsiyonDiv">
                                <div>Planlanan Uygulama:</div>
                                <div>{{item.ekTedavi}}</div>
                            </div>
                            <div v-if="item.ekUrun !==''" class="opsiyonDiv">
                                <div>Protetik Ürün:</div>
                                <div>{{item.ekUrun}}</div>
                            </div>
                            <div v-if="item.lotNo !==''" class="opsiyonDiv">
                                <div>Lot:</div>
                                <div>{{item.lotNo}}</div>
                            </div>
                            <div v-if="item.isq !==''" class="opsiyonDiv">
                                <div>ISQ:</div>
                                <div>{{item.isq}}</div>
                            </div>
                            <div class="opsiyonDiv">
                                <div>Açıklama:</div>
                                <div>{{item.aciklama}}</div>
                            </div>
                            <div class="disler-arasi-cizgi" v-if="index < hastaRandevuListesi.length - 1"></div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>

            <span slot="footer" class="dialog-footer">
    <el-button style="visibility: hidden">Cancel</el-button>
  </span>
        </el-dialog>
        <el-dialog
                title='Tarihe Göre Filtreleme'
                :visible.sync="filterDialogVisible"
                width="30%"
                center>
            <el-date-picker
                    v-model="tarih"
                    type="daterange"
                    :picker-options="dateRangeOptions"
                    :default-time="['23:59:00']"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="Başlangıç Tarihi"
                    end-placeholder="Bitiş Tarihi">
            </el-date-picker>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="filtrele(), filterDialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="filterDialogVisible = false"></el-button>
                </span>
        </el-dialog>
        <modal-dash v-if="dialogVisibleRandevu" :dialogvisible.sync="dialogVisibleRandevu"
                    :userdata=secilenHasta></modal-dash>
        <hasta-surec-detay v-if="dialogHastaSurec" :userdata="userdata" :dialogvisible.sync="dialogHastaSurec"></hasta-surec-detay>
        <hekim-detay v-if="dialogHekimDetay" :userdatahekim="userdatahekim" :dialogvisible.sync="dialogHekimDetay"></hekim-detay>
    </div>
</template>

<script>
    import RandevuEkle from '@/components/RandevuEkle'
    import ModalDash from '@/components/ModalDash'
    import HastaSurecDetay from '@/components/HastaSurecDetay'
    import EventBus from '@/components/event-bus'
    import HekimDetay from '@/components/HekimDetay'

    import hastaService from '../../../WSProvider/HastaService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import JQuery from 'jquery';
    import Vue from 'vue'
    import excel from 'vue-excel-export'

    Vue.use(excel)
    let $ = JQuery;
    let base64 = require('base64_js');
    let userData3H = "";
    export default {
        name: "HastaListesi",
        components: {
            RandevuEkle,
            HastaSurecDetay,
            HekimDetay,
            ModalDash
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userData3H")) {
                userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                if (userData3H["tur"]) {
                    if (userData3H["tur"] === '1') {
                        self.root = true;
                    } else if (userData3H["tur"] === '2' || userData3H["tur"] === '3') {
                        self.yetkili = true;
                    }
                }
            }
            this.getHastaCount();
            this.hastaCount();
            this.getHastaListesi();
            EventBus.$on('hastaList', function (bool) {
                if (bool) {
                    self.getHastaCount();
                    self.getHastaListesi();
                    self.hastaCount();
                }
            });
        },
        data() {
            return {
                dialogTableVisibleTakvim: false,
                dialogHastaSurec: false,
                dialogHekimDetay: false,
                visible : false,
                teslimTarihi: '',
                reddedilen: '',
                tamamlanan: '',
                onaybekliyor: '',
                islemde: '',
                pasif: '',
                randevu: '',
                hastaId: '',
                hekimId: '',
                dialogVisibleRandevu: false,
                hekimVisible: false,
                hastaDetaySurec: false,
                secilenHasta: {},

                dateRangeOptions: {
                    firstDayOfWeek: 1
                },
                excelTable: [],
                yetkiList: {
                    hastaOnay: false,
                    islemde: false,
                    pasif: false,
                    randevu: false,
                    uretim: false,
                    sinterleme: false,
                    polisaj: false,
                    sonKontrol: false,
                    kargo: false,
                    hatali: false,
                },
                selectionDoktor: '',
                protezAdi: '',
                hekimAdi: '',
                hekimTel: '',
                protezTel: '',
                hekimMail: '',
                hastaSehir: '',
                hastaisimSoyisim: '',
                hastaCinsiyet: '',
                hastaYas: '',
                hastaMail: '',
                hastaAdres: '',
                hastatcNo: '',
                hekimKlinik: '',
                hastaTel: '',
                hastaRandevuListesi: [],
                hastaCerrahiListesi: [],
                urun: '',
                ekUrun: '',
                ekTedavi: '',
                userdata: {},
                userdatahekim: {},
                tarih: '',
                page: 0,
                sizes: 20,
                postPage: 0,
                total: null,
                durumChangeDialog: false,
                filterDialogVisible: false,
                surecVisible: true,
                dialogVisibleDoktor: false,
                dialogVisibleBelge: false,
                selectIcon: this.$store.state.hastaListDurum,
                radio: this.$store.state.hastaListDurum,
                root: false,
                yetkili: false,
                search: '',
                selection: '',
                selectionIndex: '',
                durum: '',
                tumHastaListesi: [],
                filtersProje: [],
                filtersDoctor: [],
            }
        },
        methods: {
            hekimDetay(scope) {
                this.userdatahekim = scope;
                this.dialogHekimDetay = true;
            },
            getHastaCount() {
                let self = this;
                hastaService.hastaCountPanel().then((response) => {
                    if (response.status === 200) {
                        if (response.tamamlanan.count !== 0) self.tamamlanan = response.tamamlanan.count;
                        if (response.islemde.count !== 0) self.islemde = response.islemde.count;
                        if (response.pasif.count !== 0) self.pasif = response.pasif.count;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            hastaDetay(scope) {
                let self = this;
                hastaService.hastaDetay(scope.hastaId).then((response) => {
                    if (response.status === 200) {
                        this.hekimAdi = response.data.hekim[0].adSoyad;
                        this.hekimTel = response.data.hekim[0].telefon;
                        this.protezAdi = response.data.hekim[1] ? response.data.hekim[1].adSoyad : '';
                        this.protezTel = response.data.hekim[1] ? response.data.hekim[1].telefon : '';
                        this.hekimMail = response.data.hekim[0].eposta;
                        this.hekimKlinik = response.data.klinikAdi;
                        this.hastaSehir = response.data.il;
                        this.hastaisimSoyisim = response.data.adSoyad;
                        this.hastatcNo = response.data.tcNo;
                        this.hastaTel = response.data.telefon;
                        this.hastaCinsiyet = response.data.cinsiyet;
                        this.hastaYas = response.data.yas;
                        this.hastaMail = response.data.eposta;
                        this.hastaAdres = response.data.adres;


                        this.hastaCerrahiListesi = response.data.cerrahi;
                        this.hastaRandevuListesi = response.data.randevu;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
                this.hastaDetaySurec = true
            },
            route(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.hastaId);
                }
                var header = functions.linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            randevuEkle(scope) {
                this.hastaId = scope.hastaId;
                this.hekimId = scope.hekimId;
                this.secilenHasta = scope;
                this.dialogVisibleRandevu = true;
            },
            filtrele() {
                hastaService.hastaTarihSearch(this.tarih[0], this.tarih[1]).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            switch (e.durum) {
                                case '0' :
                                    e.durumDetay = 'Reddedildi';
                                    break;
                                case '1' :
                                    e.durumDetay = 'Tamamlandı';
                                    break;
                                case '2' :
                                    e.durumDetay = 'Onay Bekliyor';
                                    break;
                                case '3' :
                                    e.durumDetay = 'Cerrahi';
                                    break;
                                case '4' :
                                    e.durumDetay = 'Randevu';
                                    break;
                            }
                        });
                        this.tumHastaListesi = response.data;
                        this.surecVisible = false;
                    } else notification.Status(response.status, this)
                })
            },
            searchMethod(val) {
                if (val !== '') {
                    var dizi = [];
                    hastaService.hastaSearch(val).then((response) => {
                        if (response.status === 200) {
                            this.surecVisible = false;
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            this.tumHastaListesi = dizi;
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            clearable() {
                this.surecVisible = true;
                this.tumHastaListesi = [];
                this.getHastaListesi();
                this.hastaCount();
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getHastaListesi();
            },
            hastaCount() {
                hastaService.hastaCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            handleCommand(durum, row, index) {
                this.selection = row;
                this.selectionIndex = index;
                this.durum = durum;
                this.durumChangeDialog = true;
            },
            garantiKartiTeslim(row) {
                hastaService.garantiKartGuncelle(row.hastaId,this.teslimTarihi).then((response) => {
                    if (response.status === 200) {
                        row.garantiKart = '1';
                        notification.Status("success", this, "Garanti Kartı Teslim Edildi..");
                    } else notification.Status(response.status, this)
                })
            },
            filterDoctor(value, row) {
                return row.hekimId === value;
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getHastaListesi();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.hastaCount();
                this.getHastaListesi();
            },
            cerrahiTanimlama(scope) {
                this.$store.commit('changeHastaKodu', scope.hastaId);
                this.$store.commit('changeHekimKodu', scope.hekim);
                this.route('Cerrahi Tanımlama');
            },
            randevuTanimlama(scope) {
                this.$store.commit('changeHastaKodu', scope.hastaId);
                this.$store.commit('changeHekimKodu', scope.hekim);
                this.$store.commit('changeRandevuTarih', '');
                this.route('Randevu Tanımlama');
            },
            getHastaListesi() {
                let self = this;
                hastaService.hastaList(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var obj1 = self.filtersDoctor.find(data => data.value === e.hekimId);
                            if (obj1 === undefined) {
                                self.filtersDoctor.push({
                                    text: e.hekim,
                                    value: e.hekimId
                                })
                            }
                        });
                        this.tumHastaListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            exportExcel() {
                let self = this;
                hastaService.hastaList(this.selectIcon, "", "").then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            switch (e.durum) {
                                case '1' :
                                    e.durumDetay = 'Tamamlandı';
                                    break;
                                case '2' :
                                    e.durumDetay = 'İşlemde';
                                    break;
                            }
                            var item = {};
                            item["Hasta ID"] = e.hastaId;
                            item["İsim Soyisim"] = e.adSoyad;
                            item["TC"] = e.tcNo;
                            item["Cinsiyet"] = e.cinsiyet;
                            item["Yaş"] = e.yas;
                            item["Kayıt Tarihi"] = e.kayitTarihi;
                            item["Hekim"] = e.hekim;
                            item["Durum"] = e.durumDetay;
                            self.excelTable.push(item);
                        });
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            hastaDurumChange(selection, index, list, durum) {
                hastaService.hastaDurumGuncelle(selection.hastaId, durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status("success", this, "Durum değişikliği başarılı..");
                        list.splice(index, 1);
                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>
<style lang="scss" scoped>
    .durum {
        position: relative;
        bottom: 3px;
    }

    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: scale(1.5, 1.5);
    }

    .el-pagination {
        float: right;
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 5px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .reddedilen .el-badge__content {
        background-color: #af0800;
        z-index: 1;
        right: 20px;
    }

    .onay .el-badge__content {
        background-color: #f7ba2a;
        z-index: 1;
        right: 20px;
    }

    .islemde .el-badge__content {
        background-color: #00bcd0;
        z-index: 1;
        right: 20px;
    }

    .silinen .el-badge__content {
        background-color: #ec205f;
        z-index: 1;
        right: 20px;
    }

    .randevu .el-badge__content {
        background-color: #6a3ab0;
        z-index: 1;
        right: 20px;
    }

    .doktoronay .el-badge__content {
        background-color: #f2de59;
        z-index: 1;
        right: 20px;
    }

    .uretim .el-badge__content {
        background-color: #ff9632;
        z-index: 1;
        right: 20px;
    }

    .sinterleme .el-badge__content {
        background-color: #f43131;
        z-index: 1;
        right: 20px;
    }

    .polisaj .el-badge__content {
        background-color: #f43131;
        z-index: 1;
        right: 20px;
    }

    .doktoronay2 .el-badge__content {
        background-color: #a027a8;
        z-index: 1;
        right: 20px;
    }

    .depo .el-badge__content {
        background-color: #0075c3;
        z-index: 1;
        right: 20px;
    }

    .kargo .el-badge__content {
        background-color: rgba(0, 117, 195, 0.41);
        z-index: 1;
        right: 20px;
    }

    .tamamlanan .el-badge__content {
        background-color: #13ce66;
        z-index: 1;
        right: 20px;
    }

    .hatali .el-badge__content {
        background-color: black;
        z-index: 1;
        right: 20px;
    }

    .not:hover {
        cursor: pointer;
    }

</style>

<style scoped>

    .hastaKabulBaslik {
        display: flex;
        justify-content: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
    }

    .hastaKabulBaslik h1 {
        background: #161c3c;
        color: #fff;
        font-weight: 700;
        padding: 8px 20px;
        position: relative;
    }

    .hastaKabulFormu {
        position: relative;
        z-index: 10;
    }

    .formBilgileri {
        display: flex;
    }

    .ozel-sagayasla {
        float: right;
    }

    .formBilgiBaslik {
        writing-mode: tb-rl;
        transform: rotate(180deg);
        float: left;
        text-align: center;
        background: #161c3c;
        color: #fff;
        padding: 12px 2px;
        text-transform: uppercase;
        font-weight: 600;
        position: relative;
        min-height: 190px;
    }

    .mobil-baslik {
        display: none;
        text-align: center;
        background: #161c3c;
        padding: 5px 2px;
        text-transform: uppercase;
        font-weight: 600;
        width: 100%;
        color: #fff;
    }

    .formElemanlari {
        padding: 0 20px !important;
    }

    .input-effect {
        position: relative;
        display: flex;
        align-items: flex-start;
    }

    .input-effect .formBilgi {
        height: 100%;
        padding: 10px 10px 0;
        font-size: 14px;
        font-weight: 500;
        flex-shrink: 0;
        min-width: 90px;
    }


    .yazdir-bilgisi {
        font-size: 14px;
        padding: 5px;
    }

    .effect-7, .effect-8, .effect-9 {
        border: 1px solid transparent;
        padding: 10px 10px 0;
        transition: .4s;
        width: 100%;
    }

    .formBilgiBaslik.sagTaraf {
        transform: none;
    }

    .formBilgiBaslik:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 27px;
        transform: translate(0, -50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 10px 0;
        border-color: transparent #161c3c transparent transparent;
    }

    .grupBilgisi {
        background: linear-gradient(90deg, rgba(22, 28, 60, 0) 5%, rgba(22, 28, 60, 0.5) 25%, rgba(22, 28, 60, 1) 40%, rgba(22, 28, 60, 1) 60%, rgba(22, 28, 60, 0.5) 75%, rgba(22, 28, 60, 0) 95%);
        font-size: 14px;
        font-weight: 500;
        padding: 8px 6px;
        text-align: center;
    }

    .grupBilgisi p {
        margin: 0;
        color: #fff;
    }

    .disOpsiyonlari {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        width: 100%;
        padding-top: 10px;
        page-break-inside: avoid;
        justify-content: start;
    }

    .yazdirFormSayfa .disNumarasi-yazdir {
        border-bottom: 1px solid #eee;
    }


    .randevular .opsiyonDiv {
        padding: 6px 5px;
        width: 15%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }

    .opsiyonDiv {
        padding: 6px 5px;
        width: 11%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }


    .doktor-bilgi {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }


    .opsiyonDiv:before {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        right: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }


    .opsiyonDiv:nth-child(1):after {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        left: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disler-arasi-cizgi {
        height: 2px;
        width: 95%;
        position: relative;
        left: 50%;
        transform: translateX(calc(-50% + -27px));
        margin: 8px 0;
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disNumarasi-yazdir div:first-child {
        color: #3cbcb4;
        text-transform: uppercase;
    }

    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .disNumarasi-yazdir div:last-child {
        font-weight: 700;
    }

    .disNumarasi-yazdir div:last-child span {
        padding: 3px 7px;
        border: 1px solid #00bcb4;
        color: #0a716b;
        display: inline-block;
    }


    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .ozel-row {
        display: flex;
        justify-content: center;
    }

    @media only screen and (max-width: 480px) {
        .opsiyonDiv:nth-child(1):after,
        .opsiyonDiv:nth-child(3):after,
        .opsiyonDiv:nth-child(5):after,
        .opsiyonDiv:nth-child(7):after {
            content: "";
            position: absolute;
            width: 2px;
            height: 100%;
            left: 0;
            top: 0;
            background: #3cbcb4;
            background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
            background: linear-gradient(transparent, #3cbcb4, transparent);
        }

        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 60px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 86px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }
</style>